import React from 'react';

import eventIcon from '@assets/icons/event.svg';
import { Table, TablePageIndicator } from '@components';
import { formatISODate } from '@utils/date';

import ActionButton from '../ActionButton';

import { eventColumns } from '../../constants/leadActivity';
import { EventTableProps } from '../../types/leadActivity';

const EventTable: React.FC<EventTableProps> = ({
  events,
  page,
  totalCount,
  setPage,
  handleMenuIconClick
}) => {
  const tableData = events.map((event) => ({
    id: event.id,
    name: event.name,
    timestamp: formatISODate({
      date: event.end_time,
      format: 'dd-mm-yyyy',
      separator: '/'
    }),
    startTime: formatISODate({ date: event.start_time, format: 'hh:mm am/pm' }),
    endTime: formatISODate({ date: event.end_time, format: 'hh:mm am/pm' }),
    actions: (
      <ActionButton
        item={event}
        handleEditAction={(item) => handleMenuIconClick(item.id, 'edit')}
        handleDeleteAction={(item) => handleMenuIconClick(item.id, 'delete')}
        actions={['edit', 'delete']}
      />
    )
  }));

  return (
    <div className="space-y-4">
      {events.length === 0 ? (
        <div className="py-8 text-center text-gray-500">
          <img src={eventIcon} alt="event" className="mx-auto mb-2" />
          <p>
            No meetings scheduled yet. Add upcoming meetings so you never miss
            an opportunity.
          </p>
        </div>
      ) : (
        <>
          <Table
            columns={eventColumns}
            data={tableData}
            isRowClickRequired={false}
            handleSelect={() => {}}
            disabledRowIds={[]}
            className="h-fit"
          />
          {totalCount > 0 && (
            <TablePageIndicator
              currentPage={page}
              totalCount={totalCount}
              onPageChange={setPage}
            />
          )}
        </>
      )}
    </div>
  );
};

export default EventTable;
